import { RootState } from "@/shared/types";

export const selectAlerts = (state: RootState): any => state.alerts;
